import * as React from "react";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import SpeakerInfo from "./SpeakerInfo";
import i18next from "i18next";
import "../css/style.css";
import offlineLogo from "../img/offline.png";
import onlineLogo from "../img/online.png";
import TranslationInstruction from "../_components/Translation/TranslationInstruction";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 600,
  maxWidth: 1000,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 10,
  p: 4,
  fontSize: 16,
  overflowY: 'auto'
};

const headerWidth = 140;

function replaceName(name) {
  if (!name) return name;

  return name;
}

function getUrls(s0) {
  console.log(s0);
  if (!s0) return;
  let s = s0;
  s0 = "<div>" + s0 + "</div>";
  console.log(s0);
  return s0;
}

export default function SlotInfo(props) {
  const [count, setCount] = React.useState(0);
  const [openQ, setQ] = React.useState(false);
  const [qtext, setQtext] = React.useState("");

  const {
    handleClose,
    sendQ,
    data,
    open,
    hasTicket,
    openSpeaker,
    isHybrid,
    questionable,
    isOrg,
  } = props;

  const mobileLayout =
    props.isMobile ||
    (typeof window !== "undefined" && window.innerWidth <= 768);


  const no_text = props.texts.to_be_specified;
  const no_url_text = props.texts.viewtrans;
  const translationInIframe = data.translation && data.translation.iframe_live;

  React.useEffect(() => {});

  function onSendQ() {
    if (qtext != "") {
      sendQ(qtext + " (" + i18next.t("quest_for") + " " + data.sp_str + ")");
      setQ(false);
      setQtext("");
    }
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            ...style,
            width: mobileLayout ? "calc(100vw - 24px)" : undefined,
            minWidth: mobileLayout ? 0 : (translationInIframe ? window.screen.width / 1.2 : 600),
            maxWidth: mobileLayout ? "calc(100vw - 24px)" : (translationInIframe ? window.screen.width / 1.2 : 1200),
            maxHeight: mobileLayout ? "calc(100vh - 24px)" : 1200,
            boxSizing: "border-box",
            overflowX: "hidden",
            overflowWrap: "anywhere",
          }}
        >
          {!mobileLayout && (
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <div style={{ fontWeight: "700", width: headerWidth }}>
                {props.texts.theme}:
              </div>{" "}
              {data.name ? replaceName(data.name) : no_text}
            </Typography>
          )}
          {mobileLayout && (
            <>
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div style={{ fontWeight: "700", width: headerWidth }}>
                  {props.texts.theme}:
                </div>
              </Typography>
              <div> {data.name ? replaceName(data.name) : no_text}</div>
            </>
          )}

          {data.description && data.description != "_service" && (
            <Typography
              id="transition-modal-description"
              sx={{ mt: 2 }}
              style={{
                display: "flex",
                flexDirection: (mobileLayout?"column":"row"),
                whiteSpace: "pre-wrap",
              }}
            >
              <div style={{ fontWeight: "700", minWidth: headerWidth }}>
                {props.texts.desc}:
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: getUrls(data.description) }}
              ></div>
            </Typography>
          )}

          {((data.description && data.description != "_service") ||
            !data.description) &&
            data.slot_type != "service_lesson" &&
            !mobileLayout && (
              <Typography
                id="transition-modal-description"
                sx={{ mt: 2 }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  whiteSpace: "pre-wrap",
                }}
              >
                <div style={{ fontWeight: "700", width: headerWidth }}>
                  {props.texts.speakers}:
                </div>{" "}
                <div>
                  {data.speakers &&
                    data.speakers.map((item, index) => (
                      <span>
                        {index > 0 ? ", " : ""}
                        <span
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => openSpeaker(item)}
                        >
                          {item.name}
                        </span>
                      </span>
                    ))}
                </div>
              </Typography>
            )}
          {((data.description && data.description != "_service") ||
            !data.description) &&
            data.slot_type != "service_lesson" &&
            mobileLayout && (
              <>
                <Typography
                  id="transition-modal-description"
                  sx={{ mt: 2 }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  <div style={{ fontWeight: "700", width: headerWidth }}>
                    {props.texts.speakers}:
                  </div>
                </Typography>
                <div>
                  {data.speakers &&
                    data.speakers.map((item, index) => (
                      <span>
                        {index > 0 ? ", " : ""}
                        <span
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => openSpeaker(item)}
                        >
                          {item.name}
                        </span>
                      </span>
                    ))}
                </div>
              </>
            )}
          {data.type != "online" && !mobileLayout && (
            <Typography
              id="transition-modal-description"
              sx={{ mt: 2 }}
              style={{
                display: "flex",
                flexDirection: "row",
                whiteSpace: "pre-wrap",
              }}
            >
              <div style={{ fontWeight: "700", width: headerWidth }}>
                {props.texts.room}:
              </div>{" "}
              {data.room_number ? data.room_number : no_text}
            </Typography>
          )}
          {data.type != "online" && mobileLayout && (
            <>
              <Typography
                id="transition-modal-description"
                sx={{ mt: 2 }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  whiteSpace: "pre-wrap",
                }}
              >
                <div style={{ fontWeight: "700", width: headerWidth }}>
                  {props.texts.room}:
                </div>
              </Typography>
              <div>{data.room_number ? data.room_number : no_text}</div>
            </>
          )}
          {!mobileLayout && (
            <Typography
              id="transition-modal-description"
              sx={{ mt: 2 }}
              style={{
                display: "flex",
                flexDirection: "row",
                whiteSpace: "pre-wrap",
              }}
            >
              <div style={{ fontWeight: "700", width: headerWidth }}>
                {props.texts.time}:
              </div>{" "}
              <div>
                {data.time ? data.time : no_text} - {data.endtime ?? ""}
              </div>
            </Typography>
          )}
          {mobileLayout && (
            <>
              <Typography
                id="transition-modal-description"
                sx={{ mt: 2 }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  whiteSpace: "pre-wrap",
                }}
              >
                <div style={{ fontWeight: "700", width: headerWidth }}>
                  {props.texts.time}:
                </div>
              </Typography>
              <div>
                {" "}
                {data.time ? data.time : no_text} - {data.endtime ?? ""}
              </div>
            </>
          )}
          {!mobileLayout &&
            data.slot_type != "service_lesson" &&
            isHybrid && (
              <Typography
                id="transition-modal-description"
                sx={{ mt: 2 }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  whiteSpace: "pre-wrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                  }}
                >
                  <div style={{ fontWeight: "700", width: headerWidth + 20 }}>
                    {props.texts.format}:
                  </div>
                  <div style={{ minWidth: 160 }}>
                    {data.type == "online" && i18next.t("online_text")}
                    {data.type == "offline" && i18next.t("offline_text")}
                    {data.type == "hybrid" && i18next.t("hybrid_text")}
                  </div>
                  {(data.type == "online" || data.type == "hybrid") && (
                    <img style={{ marginLeft: 10 }} src={onlineLogo} />
                  )}
                  {(data.type == "offline" || data.type == "hybrid") && (
                    <img style={{ marginLeft: 10 }} src={offlineLogo} />
                  )}
                </div>
              </Typography>
            )}

          {mobileLayout && data.slot_type != "service_lesson" && isHybrid && (
            <>
              <Typography
                id="transition-modal-description"
                sx={{ mt: 2 }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  whiteSpace: "pre-wrap",
                }}
              >
                <div style={{ fontWeight: "700", width: headerWidth + 20 }}>
                  {props.texts.format}:
                </div>
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "start",
                }}
              >
                <div>
                  {data.type == "online" && i18next.t("online_text")}
                  {data.type == "offline" && i18next.t("offline_text")}
                  {data.type == "hybrid" && i18next.t("hybrid_text")}
                </div>
                {(data.type == "online" || data.type == "hybrid") && (
                  <img style={{ marginLeft: 10 }} src={onlineLogo} />
                )}
                {(data.type == "offline" || data.type == "hybrid") && (
                  <img style={{ marginLeft: 10 }} src={offlineLogo} />
                )}
              </div>
            </>
          )}
          {(hasTicket || isOrg) && (<>
            <div style={{ marginTop: 10 }}>
              {!openQ &&
                data.slot_type != "service_lesson" &&
                questionable == 1 && (
                  <Button onClick={() => setQ(true)}>
                    {props.texts.ask_q}
                  </Button>
                )}

              {openQ && (
                <div style={{ marginTop: 10, fontSize: 16 }}>
                  <span>{props.texts.qtext}</span>
                  <textarea
                    id="area1"
                    className="form__input"
                    placeholder={props.texts.text}
                    name="q"
                    multiline
                    onChange={(e) => setQtext(e.target.value)}
                    value={qtext}
                    style={{ marginTop: 5 }}
                  />
                  <Button onClick={onSendQ}>{props.texts.send}</Button>
                  <Button
                    onClick={() => {
                      setQ(false);
                      setQtext("");
                    }}
                  >
                    {props.texts.cancel}
                  </Button>
                </div>
              )}
            </div>
            {data.url_online && !translationInIframe &&
              <div className="common-link">
                <a href={data.url_online} target="_blank">{no_url_text}</a>
              </div>
            }
            {data.translation && <div style={{ marginTop: 10, fontSize: 16 }}>
              <div style={{display: "flex"}}>
                {translationInIframe && <div
                  style={{ border: "1px solid black", float: "left", width: "75%" }}
                  dangerouslySetInnerHTML={{
                    __html: data.translation.iframe_live,
                  }}
                ></div>}
                {data.translation.iframe_chat && <div
                  style={{ border: "1px solid black", width: "25%", marginLeft:"10px", float: "right"}}
                  dangerouslySetInnerHTML={{
                    __html: data.translation.iframe_chat,
                  }}
                ></div>}
              </div>
              {isOrg && data.translation.stream_url && 
                <TranslationInstruction translation={data.translation} />
              }
            </div>}
          </>)}
        </Box>
      </Fade>
    </Modal>
  );
}
